export const WABA_API_STATUS_PENDING = "Pending";
export const WABA_API_STATUS_APPROVED = "Approved";
export const WABA_API_STATUS_REJECTED = "Rejected";
export const WABA_API_STATUS_APPROVAL_IN_PROGRESS = "Approval In Progress";
export const WABA_API_STATUS_PENDING_BUSINESS_MANAGER_VERIFICATION =
  "Pending Business Manager Verification";
export const WABA_API_STATUS_DETAILS_REQUIRED = "Details Required";
